export default {
  // 轻应用 Astro Zero 跳转地址
  astroZeroUrl:
    "http://appcube.cn-north-4.huaweicloud.com/cas/clientredirect?service=https%3A%2F%2Fappcube.cn-north-4.huaweicloud.com%2Fbaas%2Fauth%2Fv1.0%2Fsso%3Fredirect_url%3D%252Fstudio%252Findex.html%2523%252Fprojects%252F&client_name=openwelink",
  // ide 使用指南
  IDEGuildUrl: `https://${location.hostname}/docs/#/qdmtm8/uug541/3u3zoj`
}
